"use client";

/**
 * V3 Firestore client (second database on the shared Firebase app).
 */
import { app } from "@/lib/firebase-app";
import { getFirestore, type Firestore } from "firebase/firestore";

const V3_DATABASE_ID = "v3db";

let _v3db: Firestore | null = null;

export function getV3Db(): Firestore {
  if (!_v3db) {
    console.log(`[v3-db] Creating Firestore instance for "${V3_DATABASE_ID}" from app "${app.name}"`);
    _v3db = getFirestore(app, V3_DATABASE_ID);
  }
  return _v3db;
}
